<div class="p-field p-fluid" id="navigation">
    <h3>Experiences</h3>
    <p-table [value]="domes" [(selection)]="selectedRows" dataKey="id" [tableStyle]="{'min-width': '50rem'}">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 4rem">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>Name</th>
                <th>Longitude</th>
                <th>Latitude</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dome>
            <tr>
                <td>
                    <p-tableCheckbox [value]="dome" (click)="onRowSelected()"></p-tableCheckbox>
                </td>
                <td>{{dome.name}}</td>
                <td>{{dome.geo.latitude}}</td>
                <td>{{dome.geo.longitude}}</td>
            </tr>
        </ng-template>
    </p-table>
  </div>